module.exports = __webpack_public_path__ + "img/jiaju2.5b015b17.png";